export function fmtDate(s, opts) {
  if (!s) return "—";
  const dstr = s.length > 10 ? s : s + "T00:00:00";
  const d = new Date(dstr);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-US", opts || { month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function relativeDays(s) {
  if (!s) return "";
  const d = new Date(s.length > 10 ? s : s + "T00:00:00");
  const days = Math.round((d - new Date()) / 86400000);
  if (days === 0) return "today";
  if (days > 0) return `in ${days} day${days === 1 ? "" : "s"}`;
  return `${-days} day${days === -1 ? "" : "s"} ago`;
}

export function timeAgo(s) {
  if (!s) return "";
  const d = new Date(s);
  const secs = (Date.now() - d) / 1000;
  if (secs < 60) return "just now";
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  if (secs < 604800) return `${Math.floor(secs / 86400)}d ago`;
  return fmtDate(s);
}

export function currency(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-US").format(n);
}
